import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=87d63440&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=87d63440&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports